import Crud from '../views/TypeUnit/Crud'
import Entity from '../views/TypeUnit/Add'

let routes = {
    path: '/type_units',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/type_units/add',
            name: 'NewTypeUnit',
            component: Entity,
            meta: {
                pageTitle: 'Tipo de Unidade',
                breadcrumb: [
                    {
                        text: 'Adicionar Tipo de Unidade',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/type_units/edit/:id?',
            name: 'EditTypeUnit',
            component: Entity,
            meta: {
                pageTitle: 'Tipo de Unidade',
                breadcrumb: [
                    {
                        text: 'Editar Tipo de Unidade',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/type_units',
            name: 'list-type-units',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos de Unidades',
                breadcrumb: [
                    {
                        text: 'Tipos de Unidades',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
